module.exports = __webpack_public_path__ + "img/lQDPDhrMurNSzsjNAkTNA5iw4DMTRQ2xyjMBfKvY8kANAA_920_580.jpg_720x720q90g.d32a56ff.jpg";